module.exports = __webpack_public_path__ + "static/media/syringe.24dc5891.svg";